export const getAnimationState = (event) =>
  event.type === 'enter' && event.scrollDirection === 'FORWARD'
    ? 'play'
    : event.type === 'enter' && event.scrollDirection === 'REVERSE'
    ? 'reverse'
    : null;
